// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__MNpOS","validationTips":"StatementDescriptor_validationTips__14czt"};